<template>
  <div>

    <div v-if="existingCustomerVault">
      <h4>
        Looks like you already have a payment account with us!
      </h4>
      <CustomerDetails :existing-customer-vault="existingCustomerVault"/>
      <div v-if="existingCustomerVault.creditCards && existingCustomerVault.creditCards.length === 0">
        <p class="error--text">
          You don't have any credit cards stored! Let's add one.
        </p>
        <button class="button button-primary button-sm"
                @click="createHostedFields"
                v-if="!showForm">Add Payment Method
        </button>
      </div>
      <div v-if="existingCustomerVault.creditCards.length > 0">
        <CardDetails :credit-cards="existingCustomerVault.creditCards" />
      </div>
    </div>

    <form id="cardForm" v-if="showForm">
      <div class="panel">
        <header class="panel__header">
          <h1>Card Payment</h1>
        </header>
        <div class="panel__content">
          <div class="textfield--float-label">
            <!-- Begin hosted fields section -->
            <label class="hosted-field--label" for="card-number"><span class="icon">
         <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M0 0h24v24H0z"
                                                                                                  fill="none"/><path
             d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/></svg></span>
              Card Number
            </label>
            <div id="card-number" class="hosted-field"></div>
            <!-- End hosted fields section -->
          </div>
          <div class="textfield--float-label">
            <!-- Begin hosted fields section -->
            <label class="hosted-field--label" for="expiration-date">
           <span class="icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path
              d="M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"/></svg>
         </span>
              Expiration Date</label>
            <div id="expiration-date" class="hosted-field"></div>
            <!-- End hosted fields section -->
          </div>
          <div class="textfield--float-label">
            <!-- Begin hosted fields section -->
            <label class="hosted-field--label" for="cvv">
          <span class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path
                d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/></svg>
            </span>
              CVV</label>
            <div id="cvv" class="hosted-field"></div>
            <!-- End hosted fields section -->
          </div>
        </div>
        <footer class="panel__footer">
          <button class="button button-primary" @click.prevent="payWithCreditCard">
            Register Card
          </button>
        </footer>
      </div>
    </form>
    <transition name="fade">
      <p v-if="error" class="error-text">
        {{ error }}
      </p>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
import * as braintree from 'braintree-web';
import CustomerDetails from '@/components/BraintreePayments/CustomerDetails';
import CardDetails from '@/components/BraintreePayments/CardDetails';

const apiUrl = "http://localhost:5001/hero-hire-1178c/us-central1/"

export default {
  name: "HostedFields",
  components: {CardDetails, CustomerDetails},
  data() {
    return {
      customerId: "196838529",
      clientToken: "",
      hostedFieldInstance: false,
      showForm: false,
      nonce: "",
      error: "",
      deviceData: "",
      subscriptionPlanId: "",
      existingCustomerVault: ""
    }
  },
  methods: {
    async generateClientToken() {
      await axios.post(`${apiUrl}braintreeGenerateClientToken`, {
        data: {
          customerId: "196838529",
        }
      }, {
        'Content-Type': 'application/json'
      })
          .then(resp => this.clientToken = resp.data.result)
    },
    async findBraintreeCustomer() {
      await this.$braintreeFunctions.post('http://localhost:5001/hero-hire-1178c/us-central1/braintreeFindClient',
          {
            data: {customerId: this.customerId}
          })
          .then(res => this.existingCustomerVault = res.data.result)
          .catch(err => {
            console.error(err)
            this.error = err
          })
    },
    async createHostedFields() {
      braintree.client.create({
        authorization: this.clientToken
      }).then(clientInstance => {
        let options = {
          client: clientInstance,
          // Add information for individual fields
          styles: {
            'input': {
              'font-size': '16px',
              'font-family': 'Ropa Sans, verdana, sans-serif',
              'font-weight': 'lighter',
              'color': 'white'
            },
            ':focus': {
              'color': 'white'
            },
            '.valid': {
              'color': '#f37333'
            },
            '.invalid': {
              'color': '#c8498c'
            }
          },
          fields: {
            number: {
              selector: '#card-number',
              placeholder: '1111 1111 1111 1111'
            },
            cvv: {
              selector: '#cvv',
              placeholder: '111'
            },
            expirationDate: {
              selector: '#expiration-date',
              placeholder: 'MM/YY'
            }
          }
        };

        this.showForm = true;

        braintree.dataCollector.create({
          client: clientInstance
        }).then(dataCollectorInstance => {
          this.deviceData = dataCollectorInstance.deviceData;
        })

        return braintree.hostedFields.create(options);
      }).then(hostedFieldInstance => {
        this.hostedFieldInstance = hostedFieldInstance;
      })
          .catch(err => {
            console.error(err)
            this.error = err
          })
    },
    async payWithCreditCard() {
      if (this.hostedFieldInstance) {
        this.nonce = ""
        this.error = ""

        this.hostedFieldInstance.tokenize().then(payload => {
          this.nonce = payload.nonce
          this.updateCustomerPaymentMethod()
        }).catch(err => {
          console.error(err);
          this.error = err.message;
        })
      }
    },
    async updateCustomerPaymentMethod() {
      await axios.post('http://localhost:5001/hero-hire-1178c/us-central1/braintreeUpdateClientPayment',
          {
            data: {
              customerId: this.customerId,
              nonce: this.nonce
            }
          }).then(res => console.log(res))
          .catch(err => {
            console.error(err)
            this.error = err

          })

      this.showForm = false
      await this.findBraintreeCustomer()
    },
    async sendPaymentTransaction() {
      this.subscriptionPlanId = 'herohire-superhero-standard';

      await axios.post('http://localhost:5001/hero-hire-1178c/us-central1/braintreeCreateSubscription', {
        data: {
          amount: 10,
          nonce: this.nonce,
          deviceData: this.deviceData,
          subscriptionPlanId: this.subscriptionPlanId
        }
      }, {
        'Content-Type': 'application/json'
      })
          .then(res => console.log(res))
          .catch(err => console.error(err))
    }
  },
  mounted() {
    this.findBraintreeCustomer();
    this.generateClientToken();

  }
}
</script>

<style lang="scss" scoped>
/*--------------------
SHARED VARIABLES
--------------------*/
$red: #e91e63;
$blue: #3f51b5;
$grey: #eae8e9;
$grey2: #f3f3f3;
$white: #fff;
$orange: #f37333;

/*--------------------
GENERAL
--------------------*/

*,
*:before,
*:after {
  box-sizing: inherit;
}

html {
  box-sizing: border-box;
  height: 100%;
  overflow: hidden;
}

body {
  font-family: 'Ropa Sans', 'Roboto', sans-serif;
  height: 100%;
}

h1 {
  font-size: 1.5em;
  font-weight: 100;
}

#cardForm {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}


/*--------------------
PANEL FORM
--------------------*/

.panel {
  width: 80%;
}

.panel__header {
  color: $white;
}

.panel__header,
.panel__footer {
  padding: 1em 2em;
}

.panel__content {
  padding: 1em 2em;
  overflow: hidden;
}

.textfield--float-label {
  width: 50%;
  float: left;
  display: inline-block;
  padding-right: 5px;
}

.hosted-field--label {
  transform: translateY(0.4em);
  font-size: 1.125em;
  line-height: 32px;
  transition: all .15s ease-out;
  display: block;
  width: 100%;
  font-weight: 400;
  overflow: hidden;
  margin-bottom: 0.5em;

  &.label-float {
    text-overflow: ellipsis;
    color: $orange;
    transition: all .15s ease-out
  }

  &.filled {
    @extend .label-float;
    color: white;
  }

  &.invalid {
    @extend .label-float;
    color: color(primary, 3);
  }
}

span.icon {
  position: relative;
  top: 0.2em;
  margin-right: 0.2em;
}

svg {
  fill: $orange;
}

.hosted-field {
  height: 32px;
  margin-bottom: 1em;
  display: block;
  background-color: transparent;
  color: white;
  border: none;
  outline: 0;
  width: 100%;
  font-size: 16px;
  padding: 0;
  box-shadow: none;
  border-radius: 0;
  position: relative;
}


/*--------------------
BT HOSTED FIELDS SPECIFIC
--------------------*/

.braintree-hosted-fields-focused {
  border-bottom: 2px solid $blue;
  transition: all 200ms ease;
}

.braintree-hosted-fields-invalid {
  border-bottom: 2px solid $red;
  transition: all 200ms ease;
}


/*---------------------
Media Queries
----------------------*/

@media (max-width: 600px) {
  html {
    overflow: auto;
  }
  #cardForm {
    height: auto;
    margin: 2em;
    font-size: 13px;
  }
  .panel {
    width: 100%;
  }
  .textfield--float-label {
    width: 100%;
    float: none;
    display: inline-block;
  }
  .pay-button {
    width: 100%;
  }
}
</style>
